export const setActiveTab = (activeTab) => {
    return {
        type: 'SET_ACTIVE_TAB_TRUCK_KANBAN',
        activeTab,
    };
};

export const addMviItem = (mvi) => {
    return {
        type: 'ADD_MVI_ITEM',
        mvi,
    };
};

export const addLabel = (label) => {
    return {
        type: 'ADD_LABEL',
        label,
    };
};


export const removeLabel = (label) => {
    return {
        type: 'REMOVE_LABEL',
        label,
    };
};

export const clearLabel = () => {
    return {
        type: 'CLEAR_LABEL'
    };
};

export const get = () => {
    return {
        type: 'GET',
    };
};

export const update = (receipts) => {
    return {
        type: 'UPDATE_TRUCK_KANBAN',
        receipts,
    };
};

export const updateMvi = (mviList) => {
    return {
        type: 'UPDATE_MVI',
        mviList,
    };
};

export const updateLabels = (labels) => {
    return {
        type: 'UPDATE_LABELS_TRUCK_KANBAN',
        labels,
    };
};


export const updateReceipt = (receipt) => {
    return {
        type: 'UPDATE_RECEIPT_TRUCK_KANBAN',
        receipt
    };
};

export const updateMassiveIndicator = (id, value) => {
    return {
        type: 'UPDATE_RECEIPT_MASSIVE_INDICATOR_TK',
        id,
        value,
    };
};

export const setResourceMvi = (resourceMvi) => {
    return {
        type: 'SET_RESOURCE_MVI_TRUCK_KANBAN',
        resourceMvi,
    };
};

//#region  Confirmação

export const resetConfirmation = () => {
    return {
        type: 'RESET_CONFIRMATION_TRUCK_KANBAN',
    };
};

export const createConfirmation = (confirmation) => {
    return {
        type: 'CREATE_CONFIRMATION_TRUCK_KANBAN',
        confirmation,
    };
};

export const insertNewConfirmation = (confirmation) => {
    return {
        type: 'INSERT_NEW_CONFIRMATION_TRUCK_KANBAN',
        confirmation,
    };
};

export const decreaseItemBalance = (partnumberCode, value) => {
    return {
        type: 'DECREASE_RECEIPT_BALANCE_TRUCK_KANBAN',
        partnumberCode,
        value,
    };
}


export const clearTruckKanban = () => {
    return {
        type: 'CLEAR_TRUCK_KANBAN'
    };
};

export const setFilter = (filter) => {
    return {
        type: 'SET_FILTER_TRUCK_KANBAN',
        filter
    };
};

export const setTransmissionsList = (transmissions) => {
    return {
        type: 'SET_TRANSMISSIONS',
        transmissions,
    };
};

export const selectTransmission = (transmission) => {
    return {
        type: 'SELECT_TRANSMISSION',
        transmission,
    };
};

export const AddDriver = (driver) => {
    return {
        type: 'ADD_DRIVER',
        driver,
    };
};
export const AddVehiclePlate = (vehiclePlate) => {
    return {
        type: 'ADD_VEHICLEPLATE',
        vehiclePlate,
    };
};
//#endregion Confirmação

export const setHighCostMaterials = (highCostMaterials) => {
    return {
        type: 'SET_HIGH_COST_MATERIALS',
        highCostMaterials,
    };
};

export const setHighCostMaterial = (highCostMaterial) => {
    return {
        type: 'SET_HIGH_COST_MATERIAL',
        highCostMaterial,
    };
};

export const setShedArea = (shedArea) => {
    return {
        type: 'SET_SHED_AREA',
        shedArea
    };
};

export const shedAreaPaged = (shedAreaPaged) => {
    return {
        type: 'SET_SHED_AREA_PAGED',
        shedAreaPaged
    };
};